import classNames from 'classnames'
import * as React from 'react'

import {noop} from '../../../../../utils/empty'
import styles from '../../../../common/Sidebar/SidebarItem/SidebarItem.css'
import type {VirtualizedTreeNodeProps} from '../../../../common/VirtualizedTree/VirtualizedTree'
import VirtualizedTreeItem from '../../../../common/VirtualizedTree/VirtualizedTreeItem/VirtualizedTreeItem'
import VirtualizedTreeOverlayItem from '../../../../common/VirtualizedTree/VirtualizedTreeOverlayItem/VirtualizedTreeOverlayItem'
import {AgentTreeItemType} from '../../AgentsSidebar/AgentsSidebar.types'
import type {
  AgentsTreeItemType,
  AgentsTreeItemPool,
  AgentsTreeItemTitle,
} from '../../AgentsSidebar/AgentsSidebar.types'
import {INDEX_ATTRIBUTE} from '../../AgentsSidebar/AgentsSidebarItem/AgentsSidebarItem'
import itemStyles from '../../AgentsSidebar/AgentsSidebarItem/AgentsSidebarItem.css'
import Title from '../../AgentsSidebar/Title/Title'

import AgentPool from './AgentPool/AgentPool'

type Props = VirtualizedTreeNodeProps &
  (AgentsTreeItemTitle | AgentsTreeItemPool) & {
    searchQuery: string
    itemKey: string
    className?: string | null | undefined
    setExpandState: (item: AgentsTreeItemType, expanded: boolean) => void
    onBlur?: (arg0: any) => void
  }
const popupHtmlProps = {
  trapFocus: false,
}
const AgentPoolsFavoriteDialogItem: React.ComponentType<Props> = React.memo(
  function AgentsSidebarItem({
    searchQuery,
    className,
    onBlur,
    setExpandState,
    index,
    style,
    height,
    width,
    indent,
    itemKey,
    parent,
    cache,
    ...item
  }) {
    const wrapperHtmlProps = React.useMemo(
      () => ({
        tabIndex: 0,
        [INDEX_ATTRIBUTE]: index,
        onBlur,
      }),
      [index, onBlur],
    )

    switch (item.type) {
      case AgentTreeItemType.TITLE:
        return (
          <VirtualizedTreeItem
            containerClassName={itemStyles.container}
            className={classNames(className, styles.item, itemStyles.title)}
            wrapperClassName={styles.itemWrapper}
            contentClassName={itemStyles.favorite}
            style={style}
            indent={indent}
          >
            <Title {...item} />
          </VirtualizedTreeItem>
        )

      default:
        return (
          <VirtualizedTreeOverlayItem
            className={classNames(className, styles.item, styles.hoverableItem)}
            activeClassName={classNames(styles.activeTitle, styles.activeItem)}
            hoveredClassName={styles.hoveredItem}
            focusedClassName={styles.focusedItem}
            wrapperClassName={styles.itemWrapper}
            onToggleExpand={noop}
            popupHtmlProps={popupHtmlProps}
            itemType={item.type}
            itemKey={itemKey}
            wrapperHtmlProps={wrapperHtmlProps}
            index={index}
            style={style}
            height={height}
            width={width}
            indent={indent}
            parent={parent}
            cache={cache}
            active={false}
            expanded={false}
            expandable={false}
          >
            <AgentPool searchQuery={searchQuery} className={styles.hoverableLink} {...item} />
          </VirtualizedTreeOverlayItem>
        )
    }
  },
)
export default AgentPoolsFavoriteDialogItem
